/** A bejövő számlák oldal nézetének (lista / táblás) kulcsa a felhasználói beállítások közt (rmgenuser_setting). */
export const viewModeControlName = "GENERAL_INCOMING_INVOICES";
export const viewModeSettingType = "ViewMode";

export type InvoiceViewMode = "list" | "table";
export const defaultViewMode: InvoiceViewMode = "list";

/** Ismeretlen vagy hiányzó mentett érték esetén az alapértelmezett nézet jön. */
export function normalizeViewMode(value: unknown): InvoiceViewMode {
  return value === "table" || value === "list" ? value : defaultViewMode;
}
